module.exports = __webpack_public_path__ + "img/2.2.4a9d5d51.png";